<template>
  <div>
    <v-btn
      :disabled="!canEdit"
      color="primary"
      :to="{ name: 'projects.edit', params: { id: projectId } }"
      class="mb-4"
      >{{ $t('Edit project') }}</v-btn
    >
    <v-responsive class="mx-auto overflow-visible">
      <div>
        <v-tabs v-model="tab" align-with-title>
          <v-tabs-slider color="primary"></v-tabs-slider>
          <template v-for="step in steps">
            <v-tab :key="step.value" v-if="showStep(step.value)">
              {{ $t(step.text) }}
            </v-tab>
          </template>
        </v-tabs>

        <v-tabs-items v-model="tab">
          <template v-for="step in steps">
            <v-tab-item :key="step.value" v-if="showStep(step.value)">
              <v-card>
                <v-card-text>
                  <component :is="step.component" :project="project" />
                </v-card-text>
              </v-card>
            </v-tab-item>
          </template>
        </v-tabs-items>
      </div>
    </v-responsive>
    <div class="text-center my-5">
      <v-btn color="secondary" @click="__back('projects.index', $event)">{{
        $t('Back')
      }}</v-btn>
    </div>
  </div>
</template>

<script>
import ShowBasicInfo from './components/ShowBasicInfo'
import Show4PMix from './components/Show4PMix'
import ShowSwot from './components/ShowSwot'
import ShowAssignment from './components/ShowAssignment'
import { get, call } from 'vuex-pathify'

export default {
  name: 'ProjectShow',
  components: {
    ShowBasicInfo,
    Show4PMix,
    ShowSwot,
    ShowAssignment
  },
  data: () => ({
    tab: null,
    steps: [
      {
        value: 'basic',
        text: 'Basic',
        component: 'ShowBasicInfo'
      },
      {
        value: '4p_mix',
        text: '4P MIX',
        component: 'Show4PMix'
      },
      {
        value: 'swot',
        text: 'SWOT',
        component: 'ShowSwot'
      },
      {
        value: 'assignment',
        text: 'Assignment',
        component: 'ShowAssignment'
      }
    ]
  }),
  computed: {
    project: get('project/project'),
    userId: get('user/id'),

    projectId() {
      return this.$route.params.id
    },

    canEdit() {
      if (!this.project?.status || !this.projectId) {
        return false
      }
      if (['completed', 'reviewed'].includes(this.project?.status)) {
        return false
      }
      if (this.project?.user_id !== this.userId) {
        return false
      }
      return true
    }
  },
  created() {
    const id = this.projectId
    if (!id) {
      alert(this.$t('Something went wrong!'))
      this.$router.push({ name: 'projects.index' })
    } else {
      const params = {
        _include: [
          'tasks.user',
          'files',
          'product',
          'places',
          'promotions',
          'price',
          'swot'
        ]
      }
      this.getProject({ id, params })
    }
  },
  methods: {
    getProject: call('project/show'),

    showStep(step) {
      if (
        step === 'basic' ||
        step === 'assignment' ||
        ((step === 'swot' || step === '4p_mix') &&
          this.project.type === 'product')
      ) {
        return true
      }
      return false
    }
  }
}
</script>
